<template>
  <div class="row form-block">
    <div class="col-lg-7">
      <div class="form-block-inner form-block-inner--selector">
        <label>{{field.name}}</label>
        <Selector
            :id="field.name"
            :filterKey="field.name"
            :selectorOptions="options"
            :options="{
              isMultiple: field.isMultipleChoice,
              mobileView: true,
              mobileViewLabel: field.name
            }"
            @change="setValue"
        />
      </div>
      <div class="form-error" v-if="validationError">
        <i class="icon-error"></i> {{field.name}} is required
      </div>
    </div>
  </div>
</template>

<script>
import Selector from "@/components/forms/Selector";
export default {
  components: {Selector},
  props: ['field', 'answers','validationError'],
  name: "SelectField",
  data() {
    return {
      selectValues: []
    }
  },
  mounted() {
    let options = []
    if(this.answers && this.answers.length > 0) {
      options = this.answers.map(elem => elem.idContentFieldOption)
    } else {
      options = this.$store.getters.userContentFieldOptions.map(elem => elem.idContentFieldOption)
    }
    this.options.forEach(option => {
      if(options.includes(option.id)) {
        this.selectValues.push(option)
      }
    })
  },
  computed: {
    options() {
      let options = []
      let values = this.$store.getters.contentFieldOptionsForIdeaBoard(this.field.idContentField);
      values.forEach(item => {
        options.push({
          id: item.idContentFieldOption,
          value: item.value,
          name: item.value,
          active: this.selectValues && this.selectValues.some(elem => {
            return elem.id === item.idContentFieldOption
          })
        })
      })
      return options;
    },
  },
  methods: {
    setValue(val) {
      this.field.values = val;
      this.selectValues = val;
      let values = this.selectValues.map(item => item.name)
      let ids = this.selectValues.map(item => item.id)
      this.$emit('changed',  {
        idContentField: this.field.idContentField,
        type:this.field.fieldType,
        files:[],
        multiple:this.field.isMultipleChoice,
        value:"",
        values: values,
        ids: ids
      },)
    },
  }
}
</script>

<style scoped>

</style>
